export default "__VITE_ASSET__202cef82__"